import NiceModal, { useModal } from '@ebay/nice-modal-react';

import Button from 'components/field/Button';
import Accordion from 'components/global/Accordion';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import { faArrowDown } from '@fortawesome/pro-solid-svg-icons';

import * as S from './FeasibilityRuleForm.styled';

/**
 * @author @omerrkosar
 */

const RuleResult = ({ data, index }) => (
	<Accordion
		header={
			<>
				<div style={{ display: 'flex' }}>
					<Typography component="h2" fontWeight="700">
						errorNumber
					</Typography>
					<Typography component="h2" fontWeight="700">
						&nbsp;{index + 1}
					</Typography>
				</div>

				<S.MessageContent>
					<Typography>shipTestResult</Typography>
					<div className="flexRow">
						{data?.ruleNames?.map((rn) => (
							<Typography component="p" className="conflictingRule" key={rn}>
								{rn}
							</Typography>
						))}
					</div>
					<Button
						style={{ padding: ' 1rem 0' }}
						variant="blueBorderless"
						icon={faArrowDown}
						label="seeOrderDetails"
						className="seeDetails"
					/>
				</S.MessageContent>
			</>
		}
		style={{ width: '100%' }}
		defaultVisible>
		<S.ResultContainerRunFeasiblity>
			{Object.entries(data.orderDetails).map(([key, value]) => (
				<div key={key} className="grid3">
					<Typography component="h3" fontWeight="700">
						{key}
					</Typography>
					<Typography>{value}</Typography>
				</div>
			))}
		</S.ResultContainerRunFeasiblity>
	</Accordion>
);
const FeasibilityRuleResultForm = NiceModal.create((data) => {
	const modal = useModal();

	return (
		<Modal fullwidth maxWidth="medium" id="feasibilityRulesResultForm" className="modal-feasibilityRulesResultForm">
			<ModalTitle>
				<Typography variant="p1">feasibilityRuleResult</Typography>
			</ModalTitle>
			<ModalContent>
				<S.FeasibilityResultContainer>
					{data?.data?.map((result, index) => (
						<RuleResult key={index} index={index} data={result}></RuleResult>
					))}
				</S.FeasibilityResultContainer>
			</ModalContent>
			<ModalActions>
				<Button
					variant="outline"
					label="close"
					onClick={() => {
						modal.remove();
					}}></Button>
			</ModalActions>
		</Modal>
	);
});

export default FeasibilityRuleResultForm;
